module.exports = __webpack_public_path__ + "media/images/common/about/icon_pet-38fe332bb8147b74e5da464ea6f7c82a.svg";